import isFunction from 'lodash/isFunction';
import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { PaymentProvider } from '@wix/cashier-common/dist/src/enums/payments/PaymentProvider';
import { type BiLogger } from '../../components/Provider/BiLogger/BiLogger';
import { type GetInitialPaymentData } from '../../types/ExternalContract';
import { logGeneralError } from '../../utils/sentry';
import { amountToLong } from '../../utils/amountToLong';
import { ecwGettingPaymentDataFromVertical } from '../../utils/bi/events/biEvents';
import { getOrderTypeByItems } from '../../utils/bi/getOrderTypeByItems';

type Params = {
  biLogger: BiLogger;
  cb?: GetInitialPaymentData;
  data: { paymentLabel: string; appInstanceId: string; currencyCode: string };
};

/**
 * Decorator for getInitialPaymentData with sending BI events
 */
export const decorateGetInitialPaymentDataWithBi = ({ biLogger, cb, data }: Params): GetInitialPaymentData => {
  if (!isFunction(cb)) {
    return cb;
  }
  return async () => {
    try {
      biLogger.report(ecwGettingPaymentDataFromVertical, {
        stepName: 'initialization',
        paymentProvider: PaymentProvider.WixPayUS,
        paymentmethod: PaymentMethod.ApplePay,

        orderSnapshotId: undefined as any, // TODO[bi]
        transactionId: undefined as any, // TODO[bi]
        isPartner: undefined as any, // TODO[bi]
        amount: undefined as any, // TODO[bi]
        currency: undefined as any, // TODO[bi]
        shippingAmount: undefined as any, // TODO[bi]
        taxAmount: undefined as any, // TODO[bi]
        discountAmount: undefined as any, // TODO[bi]
        cartId: undefined as any, // TODO[bi]
        productid: undefined as any, // TODO[bi]
        orderType: undefined as any, // TODO[bi]
        result: undefined as any, // TODO[bi]
        errorReason: undefined as any, // TODO[bi]
      });
      const { paymentAmount, paymentBreakdown, orderItems } = await cb();

      biLogger.report(ecwGettingPaymentDataFromVertical, {
        amount: amountToLong(paymentAmount),
        currency: data.currencyCode,
        stepName: 'result',
        result: 'success',
        paymentProvider: PaymentProvider.WixPayUS,
        paymentmethod: PaymentMethod.ApplePay,
        shippingAmount: amountToLong(paymentBreakdown.shipping),
        taxAmount: amountToLong(paymentBreakdown.tax),
        discountAmount: amountToLong(paymentBreakdown.discount),
        orderType: getOrderTypeByItems(orderItems),

        orderSnapshotId: undefined as any, // TODO[bi]
        transactionId: undefined as any, // TODO[bi]
        isPartner: undefined as any, // TODO[bi]
        cartId: undefined as any, // TODO[bi]
        productid: undefined as any, // TODO[bi]
        errorReason: undefined as any, // TODO[bi]
      });
      return { paymentAmount, paymentBreakdown, orderItems };
    } catch (e) {
      biLogger.report(ecwGettingPaymentDataFromVertical, {
        stepName: 'result',
        result: 'failure',
        paymentProvider: PaymentProvider.WixPayUS,
        paymentmethod: PaymentMethod.ApplePay,
        errorReason: e.message,

        orderSnapshotId: undefined as any, // TODO[bi]
        transactionId: undefined as any, // TODO[bi]
        isPartner: undefined as any, // TODO[bi]
        amount: undefined as any, // TODO[bi]
        currency: undefined as any, // TODO[bi]
        shippingAmount: undefined as any, // TODO[bi]
        taxAmount: undefined as any, // TODO[bi]
        discountAmount: undefined as any, // TODO[bi]
        cartId: undefined as any, // TODO[bi]
        productid: undefined as any, // TODO[bi]
        orderType: undefined as any, // TODO[bi]
      });
      logGeneralError({
        message: 'getInitialPaymentData throws',
        payload: e,
      });
      throw e;
    }
  };
};
